import { F_MapMarkerDirectionFragment } from '__generated__v2/graphql';
import { coordsToArrays } from 'libs/utils/3d/3dUtils';
import { isNil, omitBy } from 'lodash';
import { LinePaint } from 'mapbox-gl';
import { ICoordinates } from 'pages/special/OsloDesignFair/map/mapTypes';
import { EmptyLayer } from 'pages/special/OsloDesignFair/map/markers/view/EmptyLayer';
import { RefObject } from 'react';
import { Layer, MapRef, Source } from 'react-map-gl';
interface Props {
    mapRef: RefObject<MapRef | null>;
    marker: F_MapMarkerDirectionFragment;
    beforeId?: string;
    onClick?: (e: MouseEvent) => void;
    orderIndex: number;
}

export const getSegmentsForDirectionMarker = (
    coordinates: ICoordinates[],
    path: ICoordinates[]
) => {
    const segments: ICoordinates[][] = [];
    let currentSegment = [path[0]];
    for (const point of path) {
        const waypoint = coordinates[segments.length + 1];
        currentSegment.push(point);

        if (!waypoint || (point.lat === waypoint.lat && point.lng && waypoint.lng)) {
            segments.push(currentSegment);
            currentSegment = [point];
        }
    }

    return segments;
};

export const DirectionMarker = (props: Props): JSX.Element => {
    const mapRef = props.mapRef;
    const { marker } = props;
    const markerId = props.marker.id;

    const segments = getSegmentsForDirectionMarker(marker.coordinates, marker.path);

    const sourceIds = segments.map((_, i) => `${markerId}|${i}`);

    const layerIds = segments.map((_, i) => ({
        layer: `${markerId}|${i}|layer`,
        layerClick: `${markerId}|${i}|clickable`,
        last: i === segments.length - 1 ? `${markerId}|last` : `${markerId}|${i}|last`
    }));

    const beforeIds = segments.map((_, i) => ({
        layer: i === 0 ? props.beforeId : layerIds[i - 1].last,
        layerClick: layerIds[i].layer,
        last: layerIds[i].layerClick
    }));

    const width = marker.width ?? 5;

    if (marker.coordinates.length < 2) {
        return <></>;
    }

    const paintAttributes: LinePaint = {
        'line-color': marker.color,
        'line-width': width,
        'line-opacity': marker.opacity ?? 1
    };

    return (
        <>
            {segments.map((segment, i) => {
                return (
                    <Source
                        key={sourceIds[i]}
                        id={sourceIds[i]}
                        type="geojson"
                        data={{
                            type: 'Feature',
                            properties: {
                                orderIndex: props.orderIndex,
                                segmentIndex: i,
                                markerId
                            },
                            geometry: {
                                type: 'LineString',
                                coordinates: coordsToArrays(segment)
                            }
                        }}
                    >
                        <Layer
                            id={layerIds[i].layer}
                            beforeId={beforeIds[i].layer}
                            source={sourceIds[i]}
                            type="line"
                            paint={{ ...omitBy(paintAttributes, isNil) }}
                            layout={{
                                'line-cap': 'round',
                                'line-join': 'round',
                                visibility: !props.marker.isHidden ? 'visible' : 'none'
                            }}
                        />
                        <Layer
                            id={layerIds[i].layerClick}
                            beforeId={beforeIds[i].layerClick}
                            source={sourceIds[i]}
                            type="line"
                            metadata={{
                                try: 'this'
                            }}
                            paint={{
                                'line-color': 'black',
                                'line-width': Math.max(width, 30),
                                'line-opacity': 0
                            }}
                            layout={{
                                visibility: !props.marker.isHidden ? 'visible' : 'none'
                            }}
                        />
                        <EmptyLayer id={layerIds[i].last} beforeId={beforeIds[i].last} />
                    </Source>
                );
            })}
        </>
    );
};
